<template>
  <v-tabs
    show-arrows
    dark
    background-color="primary"
    v-model="tab"
    height="100px"
    class="mb-5"
    icons-and-text
    fixed-tabs
    centered
  >
    <v-tab
      v-for="tab in tabs"
      :key="tab"
      @click="$router.push(`/recharge?way=${tab}`)"
    >
      {{ tab }}
      <image-view
        width="50px"
        class="mb-2"
        height="50px"
        :src="getImage(tab)"
      ></image-view>
    </v-tab>
  </v-tabs>
</template>

<script>
import ImageView from "../ImageView.vue";
export default {
  components: { ImageView },
  data() {
    return {
      tab: -1,
      tabs: [
        "Prepaid",
        "Postpaid",
        "STV",
        "DTH",
        "Broadband",
        "Electricity",
        "Gas",
        "Water",
      ],
    };
  },
  methods: {
    getImage(tab) {
      tab = tab.toLowerCase();
      return require(`../../assets/images/${tab}.svg`);
    },
  },
};
</script>

<style>
</style>